import is from 'is_js';

export const isBrowser = () => typeof window !== 'undefined';

export const getUser = () =>
  isBrowser() && window.localStorage.getItem('user')
    ? JSON.parse(window.localStorage.getItem('user'))
    : {};

export const setUser = (user) =>
  isBrowser() && window.localStorage.setItem('user', JSON.stringify(user));

export const isLoggedIn = () => {
  const user = getUser();

  return is.existy(user?.id);
};

export const logout = () =>
  isBrowser() && window.localStorage.getItem('user')
    ? window.localStorage.removeItem('user')
    : null;
